const ROOT_SELECTOR = '.content-for-layout:has(.bws-pdp-shell)';
const PRODUCT_RAIL_SELECTOR = '.bws-pdp-shell__product-navigation';

function wheelDeltaY(event, root) {
  if (event.deltaMode === 1) return event.deltaY * 16;
  if (event.deltaMode === 2) return event.deltaY * root.clientHeight;
  return event.deltaY;
}

function scrollRootBy(root, deltaY) {
  const previousTop = root.scrollTop;
  const maximumTop = Math.max(0, root.scrollHeight - root.clientHeight);
  root.scrollTop = Math.min(maximumTop, Math.max(0, previousTop + deltaY));
  return root.scrollTop !== previousTop;
}

function bindProductRailScroll(root) {
  const rail = root.querySelector(PRODUCT_RAIL_SELECTOR);
  if (!rail || rail.dataset.bwsPrimaryScrollBound === 'true') return;

  rail.dataset.bwsPrimaryScrollBound = 'true';
  let lastTouchY = null;

  rail.addEventListener(
    'wheel',
    (event) => {
      if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      if (scrollRootBy(root, wheelDeltaY(event, root))) event.preventDefault();
    },
    { passive: false },
  );

  rail.addEventListener(
    'touchstart',
    (event) => {
      lastTouchY = event.touches.length === 1 ? event.touches[0].clientY : null;
    },
    { passive: true },
  );

  rail.addEventListener(
    'touchmove',
    (event) => {
      if (lastTouchY === null || event.touches.length !== 1) return;

      const nextTouchY = event.touches[0].clientY;
      const deltaY = lastTouchY - nextTouchY;
      lastTouchY = nextTouchY;
      if (scrollRootBy(root, deltaY)) event.preventDefault();
    },
    { passive: false },
  );

  const clearTouch = () => {
    lastTouchY = null;
  };

  rail.addEventListener('touchend', clearTouch, { passive: true });
  rail.addEventListener('touchcancel', clearTouch, { passive: true });
}

function bindPageGutterScroll(root) {
  if (root.dataset.bwsGutterScrollBound === 'true') return;

  root.dataset.bwsGutterScrollBound = 'true';
  document.addEventListener(
    'wheel',
    (event) => {
      if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

      const rootBounds = root.getBoundingClientRect();
      const isPageGutter = event.clientX < rootBounds.left || event.clientX > rootBounds.right;
      if (!isPageGutter) return;

      if (scrollRootBy(root, wheelDeltaY(event, root))) event.preventDefault();
    },
    { passive: false },
  );
}

function bind(root) {
  if (!root) return;

  bindProductRailScroll(root);
  bindPageGutterScroll(root);
}

function init() {
  bind(document.querySelector(ROOT_SELECTOR));
}

init();
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:reorder', init);
